import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const DataDeletionPolicy: React.FC = () => {
  return (
    <PolicyLayout title="Data Deletion Policy" image="/images/fhome-ghee-sweets.jpg">
      <p>
        At FHome, we respect your privacy and provide a simple way to request deletion of your personal
        data. This policy explains how to request deletion and the circumstances under which we may retain
        information for legal or operational reasons.
      </p>

      <h3>How to Request Deletion</h3>
      <p>
        You may request deletion of your account and personal data by emailing us at{' '}
        <a href="mailto:care@fhome.shop">care@fhome.shop</a> with the subject “Data Deletion Request”.
        Please include your full name, registered email address, and any order-related details that help us
        verify your identity.
      </p>

      <h3>Information Covered</h3>
      <ul>
        <li>Account profile information such as name, phone number, email address, and delivery address.</li>
        <li>Order history, purchase records, and customer support communications.</li>
        <li>Saved preferences, wallet or wishlist information if available in the platform.</li>
        <li>Any other personal data collected through the website or mobile app.</li>
      </ul>

      <h3>Deletion Timeline</h3>
      <p>
        We aim to process valid deletion requests within 30 days from the date of verification. In some
        cases, we may need additional time if the request is complex or if it requires review for legal,
        security, or fraud-prevention purposes.
      </p>

      <h3>Retention Exceptions</h3>
      <p>
        We may retain certain information where required by law, for tax or accounting obligations,
        for resolving disputes, or to protect against fraud and abuse. Any retained information will be
        limited to what is necessary and handled in accordance with applicable legal requirements.
      </p>

      <h3>Operational Note</h3>
      <p>
        If your request is submitted through an app store account or customer support channel, we will
        validate the request before deleting data to protect against unauthorized access. Once deleted,
        data may no longer be recoverable.
      </p>

      <h3>Contact</h3>
      <p>
        For any data deletion or privacy-related questions, contact us at{' '}
        <a href="mailto:care@fhome.shop">care@fhome.shop</a> or call +91 9148761750.
      </p>
    </PolicyLayout>
  );
};

export default DataDeletionPolicy;
